import { render } from "./iconOrders.vue?vue&type=template&id=1c536c9c"
import script from "./iconOrders.vue?vue&type=script&lang=js"
export * from "./iconOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__